import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=578ab52c&scoped=true&"
import script from "./TopBar.vue?vue&type=script&setup=true&lang=js&"
export * from "./TopBar.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578ab52c",
  null
  
)

export default component.exports